import React from 'react'
import Cursor from '../components/cursor'
import Layout from '../components/layout'
import Seo from '../components/seo'
import Title from '../components/title'
import Spacer from '../components/spacer'
import ContactForm from '../components/contactForm'
import { graphql } from 'gatsby'

export default function contact({ data }) {
    return (
        <>
        <Cursor />
        <Layout footer='contact'>
            <Seo title="Contact" />
            <Spacer />
            <Spacer className='m-hide' />
            <Title text='Contact' className='h1' />
            <Spacer className='m-hide' />
            <Spacer />
            <ContactForm />
            <Spacer />
           
        </Layout>
        </>
    )
}

export const query = graphql`
    query ContactPage {
        page:datoCmsContactPage{
            nextPage{
                ...NextPage
            }
        }
    }
`